var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRhpShoppingCartWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "26px",
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icRHPShoppingCartWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RHP-store-cart-3",
    transform: "translate(-96.000000, -748.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 666.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-2",
    transform: "translate(18.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "images"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(79.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icRHPShoppingCartWhite"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3652195,21.5653626 C12.3652195,20.2340172 11.286021,19.1548187 9.95491414,19.1548187 C8.62356873,19.1548187 7.5443702,20.2340172 7.5443702,21.565124 C7.5443702,22.8964695 8.62356873,23.9756679 9.95491414,23.9756679 C11.2853053,23.9742366 12.3637882,22.8959924 12.3652195,21.5653626 Z M8.39933203,21.5653626 C8.39933203,20.7061069 9.09565838,20.0097805 9.95491414,20.0097805 C10.8139313,20.0097805 11.5102576,20.7061069 11.5102576,21.565124 C11.5102576,22.4243798 10.8139313,23.1207061 9.95491414,23.1207061 C9.09613551,23.1197519 8.40028629,22.4239027 8.39933203,21.5653626 Z",
    id: "Shape",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8804867,23.9756679 C20.2118321,23.9759065 21.2910305,22.896708 21.2910305,21.5653626 C21.2912691,20.2340172 20.2120706,19.1548187 18.8807252,19.1548187 C17.5493798,19.1548187 16.4701813,20.2340172 16.4701813,21.5653626 C16.4718511,22.8957538 17.5498569,23.9739981 18.8804867,23.9756679 Z M18.8804867,20.0097805 C19.7395038,20.0097805 20.4360687,20.7061069 20.4360687,21.565124 C20.4363072,22.4241412 19.7397424,23.1207061 18.8807252,23.1207061 C18.021708,23.1207061 17.3251431,22.4243798 17.3251431,21.5653626 C17.3260973,20.7068225 18.0219466,20.0109733 18.8804867,20.0097805 Z",
    id: "Shape",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.427480916,0.916030534 L3.03506681,0.916030534 C3.89312977,0.912690809 4.62476147,1.53745227 4.75548666,2.38573472 L6.81965649,15.4246183 C7.01455151,16.6889313 8.10520037,17.6204675 9.38454198,17.615458 L22.1436068,17.615458 C22.3795325,17.615458 22.5710878,17.4239027 22.5710878,17.1879771 C22.5710878,16.951813 22.3795325,16.7604962 22.1436068,16.7604962 L9.38454198,16.7604962 C8.52647902,16.7638358 7.79484733,16.1388359 7.66412214,15.290792 L7.31321563,13.0739504 L20.3807252,13.0739504 C21.4871183,13.0734733 22.4718511,12.3726145 22.8344465,11.3275286 L25.2588263,4.33039121 C25.3043893,4.19966602 25.2836355,4.05510498 25.2034828,3.94227102 C25.1230916,3.8296756 24.9933206,3.76264311 24.8549618,3.76264311 L5.83897899,3.76264311 L5.59995231,2.2519084 C5.40505722,0.98759542 4.31440843,0.0560591634 3.03506681,0.0610687023 L0.427480916,0.0610687023 C0.191316763,0.0610687023 2.84217094e-14,0.252624061 2.84217094e-14,0.488549618 C2.84217094e-14,0.724713771 0.191316763,0.916030534 0.427480916,0.916030534 Z M24.2542939,4.61784354 L22.0267176,11.0474714 C21.7833969,11.7485687 21.1228531,12.21875 20.3807252,12.2189886 L7.17771945,12.2189886 L5.97423664,4.61760495 L24.2542939,4.61784354 Z",
    id: "Shape"
  })))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRhpShoppingCartWhite);
export default __webpack_public_path__ + "static/media/icRHPShoppingCartWhite.5e67dd5436dc39bff6b72f7cac69735a.svg";
export { ForwardRef as ReactComponent };